<div id="dark" class="noprint px-5" style="padding-top:120px; min-height:100vh;">
  <div class="text-center text-color-theme" >
    <h2>{{'my-invoices'|translate}}</h2>
  </div>
  <br>
  <div class="row d-flex justify-content-xl-center justify-content-lg-center justify-content-start">
    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
      <label class=" text-color-theme" style="float: right;">{{"date-from"|translate}}</label>

      <input (focus)="pickerFrom.open()" class="form-control" #date id="date" matInput name="depositDate" [(ngModel)]="dateFrom" [matDatepicker]="pickerFrom" [max]="dateTo || maxDate" readonly>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </div> -->
    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
      <label class=" text-color-theme" style="float: right;">{{"date-to"|translate}}</label>

      <input 
        (focus)="pickerTo.open()" 
        class="form-control" 
        matInput 
        name="depositDateTo" 
        [(ngModel)]="dateTo" 
        [matDatepicker]="pickerTo" 
        [min]="dateFrom || null" 
        [max]="maxDate" 
        readonly
      >
      <mat-datepicker #pickerTo></mat-datepicker>
    </div> -->
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
      <label class="text-color-theme" style="float: right;">{{"select-account" |translate}}</label>
      <ng-select class="custom w-100" [(ngModel)]="selectedClient" (change)="onSelectClient($event?.target?.value)">
        <ng-option *ngFor="let acc of accList;let i = index" value="{{acc.relationCode}}">
          ({{acc.relationCode}}) {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}</ng-option>
      </ng-select>

     <mat-progress-bar *ngIf="isInvoicesLoading" class="example-margin" [color]="'primary'" [mode]="'indeterminate'"
          [value]="50" [bufferValue]="75">
        </mat-progress-bar>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-12">
        <label class="text-color-theme textAlign" [ngStyle]="translate.currentLang == 'en' && { float: 'left' }">{{
          "date-from" | translate }}</label>

        <input (focus)="pickerFrom.open()" class="form-control" #date id="date" matInput name="depositDate"
          [(ngModel)]="dateFrom" [matDatepicker]="pickerFrom" [max]="dateTo || maxDate" readonly/>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-12">
        <label class="text-color-theme textAlign" [ngStyle]="translate.currentLang == 'en' && { float: 'left' }">{{
          "date-to" | translate }}</label>

        <input (focus)="pickerTo.open()" class="form-control" #date id="date" matInput name="depositDate"
          [(ngModel)]="dateTo" [matDatepicker]="pickerTo" [max]="dateTo || maxDate" readonly/>
        <mat-datepicker #pickerTo></mat-datepicker>
      </div>
    <div class="row settings-notification align-items-end justify-content-between mt-2">
      <div class="col-xl-3 col-lg-3 col-md-3 col-12 mt-sm-3 mt-3">
        <div class="mb-3 d-flex justify-content-between">
          <div>
            <h6 class="profile-heading text-color-theme">
              {{ "Arabic" | translate }}
            </h6>
          </div>
          <div>
            <mat-slide-toggle color="primary" [(ngModel)]="isReportArabic">
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex justify-content-end">
        <button class="btn btn-search btn-primary" (click)="onDateChange()">
          {{ "preview" | translate }}
        </button>
      </div>
  </div>



  <div *ngIf="!invoices && !isInvoicesLoading" class="text-center m-5 mx-auto" style="width: 60%;">
    <img class="empty-state" src="/assets/img/noData.png" />
    <div class="col-sm-12">
      <h6 class="text-warning mt-2">  {{'no-invoice'|translate}} </h6>
    </div>
  </div>
  <div *ngFor="let item of invoices" style="height: fit-content;width: 100%;" dir="rtl" class="container" id="wholeInvoice">

    <div class="mx-2" style="page-break-after:always">
      <br>
      <div class="market-pairs">
        <div class="text-color-theme p-3">
          <div class="row mx-1">
            <div class="col-4" style="text-align: center;">
                <h6>نوع العملية: {{isArabic? item.TransactionTypeA:item.TransactionTypeE}}</h6>
            </div>

            <div class="col-4" style="text-align: center;">
                <h6>السوق: {{isArabic? item.MarketNameA:item.MarketNameE}}</h6>
                <h6>الفرع: {{isArabic? item.BranchNameA:item.BranchNameE}}</h6>
            </div>
          </div>
        </div>
        <div class="tab-content scroll-auto">
          <div class="tab-pane fade show active table-custom" id="recent-trades" role="tabpanel">
            <table class="table table-sm">
              <thead style="z-index: 100;">
                <th class="fit">رقم الفاتورة</th>
                <th class="fit">تاريخ الفاتورة</th>
                <th class="fit">الورقة</th>
                <th class="fit">الكمية</th>
                <th class="fit">م. السعر</th>
                <th class="fit">القيمة</th>
                <th></th>
              </thead>
              <tbody>
                <tr>
                    <td class="fit">{{item.PostedSerial}}</td>
                    <td class="fit">{{item.InvoiceDate|date}}</td>
                    <td class="fit">{{isArabic? item.SymbolNameA:item.SymbolNameE}}</td>
                    <td class="fit">{{item.Qty | number}}</td>
                    <td class="fit">{{item.AvgPrice| number: "1.2-2":"en-US"}}</td>
                    <td class="fit">{{item.NetAmount | number: "1.2-2":"en-US"}}</td>
                    <td class="fit">
                    <!-- <button *ngIf="invoice != selectedInvoice" (click)="selectInvoice(invoice)" class="btn btn-sm btn-primary">
                      {{"preview"|translate}}
                    </button> -->
                    <button class="btn btn-sm btn-primary" (click)="tryGenerate(item)">{{"preview"|translate}}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
    <br>

  </div>

</div>
<div *ngIf="!invoices && !isInvoicesLoading" class="text-center m-5 mx-auto" style="width: 60%">
    <img class="empty-state" src="/assets/img/noData.png" />
    <div class="col-sm-12">
      <h6 class="text-warning mt-2" *ngIf="selectedClient">
        {{'no-invoice'|translate}}
      </h6>
      <h6 class="text-warning mt-2" *ngIf="!selectedClient">
        {{'choose-client'|translate}}
      </h6>
    </div>
  </div>
  <div class="app-print-page">
    <app-invoice-details *ngIf="selectedInvoice" id="print-section" [invoice]="selectedInvoice"></app-invoice-details>
  </div>

<!-- <app-statement-details id="print-section" ></app-statement-details> -->
